import { ActionsThatCanBeCancelled } from '@colonist/game-base-types';
import { TurnState } from '@colonist/game-states';
import { ArrayUtils } from '@colonist/utils';
export const getTranslationObjectForClickState = (isMyTurn, actionState, turnState)=>{
    if (!isMyTurn) return {
        key: 'strings:game.errors.notYourTurn'
    };
    if (!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, actionState)) return {
        key: 'strings:game.errors.finishCurrentAction'
    };
    if (turnState == TurnState.SpecialBuildPhase) return {
        key: 'strings:game.errors.tradingDisabled'
    };
    if (turnState != TurnState.Turn) return {
        key: 'strings:game.errors.finishCurrentAction'
    };
    return undefined;
};
